import { Col, Form, Row,Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { useNavigate } from "react-router-dom";
import { FC } from "react";
import endPoints from "apps/CustomerPanel/MLS/Components/Portfolio/EndPoints"

import { useQueryClient } from "react-query";
import { handleResetAllAdvertState } from "../../ClientSideStates";
import { useDispatch } from "react-redux";

interface SuccessPaymentProps{
  setIsShowSuccessPaymentModal?:any
}

const SuccessPayment:FC<SuccessPaymentProps> = ({setIsShowSuccessPaymentModal}) => {
  const [form] = Form.useForm();
  const queryClient = useQueryClient()
const dispatch = useDispatch()

  const { Text } = Typography;
  const navigate = useNavigate();
  return (
    <>
      <MazakaForm
        submitButtonVisible={false}
        form={form}
       
      >
        <Row gutter={[10, 20]} className="!px-4">
          <Col xs={24} className="!flex justify-center">
            <LazyLoadImage
              wrapperWidth="200px"
              wrapperHeight="200px"
              src="https://cdn-icons-png.flaticon.com/512/9245/9245020.png"
              alt=""
            />
          </Col>
          <Col xs={24}>
            <Row>
              <Col xs={24} className="!flex justify-center">
                <Text className="!text[#164194] !text-base">
                  Ödemenız başarılı bir şekilde tamalandı
                </Text>
              </Col>
              <Col xs={24} className="!flex justify-center">
                <Text className="!text[#164194]  !text-gray-400 !text-sm">
                  Sarı İlanları seçtiğiniz için teşekkür ederiz. İstediğiniz
                  sayfayı seçiniz
                </Text>
              </Col>
            </Row>
          </Col>

          <Col xs={24} className="!flex gap-3 justify-center">
            <MazakaButton className="!p-4 !bg-[#FFC502] !text-black"
            onClick={()=>{
              navigate("/admin/panel?activePanelMenu=profile")
              setIsShowSuccessPaymentModal(false)
              queryClient.resetQueries({
                queryKey: endPoints.getUserAdvertList,
                exact: false,
              });
             dispatch(handleResetAllAdvertState());
            }}
            >
              Profile git
            </MazakaButton>
            <MazakaButton className="!bg-black !text-white"
             onClick={()=>{
              navigate("/admin/panel?activePanelMenu=myAdverts")
              setIsShowSuccessPaymentModal(false)
              queryClient.resetQueries({
                queryKey: endPoints.getUserAdvertList,
                exact: false,
              });
              dispatch(handleResetAllAdvertState());
            }}
            >
              İlanlarımı Göster
            </MazakaButton>
          </Col>
        </Row>
      </MazakaForm>
    </>
  );
};

export default SuccessPayment;
